import { DealData } from './DealData';

export default DealData;
